import '@/styles/globals.css'

import type { FC, ReactNode } from 'react'
import type { AppProps } from 'next/app'

import Head from 'next/head'
import { Bricolage_Grotesque, JetBrains_Mono, Manrope } from 'next/font/google'
import { Toaster } from 'sonner'

const sans = Manrope({
    subsets: ['latin']
})

const mono = JetBrains_Mono({
    subsets: ['latin']
})

const heading = Bricolage_Grotesque({
    subsets: ['latin']
})

const fontVariables = `:root{--font-app-sans:${sans.style.fontFamily};--font-app-mono:${mono.style.fontFamily};--font-app-heading:${heading.style.fontFamily}}`

const App: FC<AppProps> = ({ Component, pageProps }): ReactNode => {
    return (
        <div className='h-full font-sans'>
            <Head>
                <style dangerouslySetInnerHTML={{ __html: fontVariables }} />
            </Head>

            <Component {...pageProps} />

            <Toaster
                position='bottom-center'
                toastOptions={{
                    className: 'font-sans !rounded-2xl !border-border !shadow-lg',
                    style: { fontFamily: 'var(--font-app-sans, ui-sans-serif, system-ui, sans-serif)' }
                }}
            />
        </div>
    )
}

export default App
